import { render } from "./DeletedBuyersView.vue?vue&type=template&id=b1f937a4"
import script from "./DeletedBuyersView.vue?vue&type=script&lang=js"
export * from "./DeletedBuyersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__